<template>
  <div id="app">
    <router-view></router-view>

    <image-dialog ref="imageDialog" :max="maxChooseImage"></image-dialog>

    <skus-dialog ref="skusDialog"></skus-dialog>
  </div>
</template>

<script>
import imageDialog from "@/components/image/image-dialog.vue";
import skusDialog from "@/components/skus/skus-dialog.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    imageDialog,
    skusDialog,
  },
  name: "app",
  // 依赖注入
  provide() {
    return {
      app: this,
    };
  },
  data() {
    return {
      maxChooseImage: 9,
    };
  },
  created() {
    // 初始化用户信息
    this.$store.commit("initUser");
    // 初始化后台菜单
    this.$store.commit("initNavBar");
  },
  async mounted() {
    // window.addEventListener("message", this.handleMessage)
    if (JSON.parse(sessionStorage.getItem("user"))) {
      await this.$openws.openws();
      await this.$openws.connect();
    } else {
      this.geturl();
    }
  },
  computed: {
    ...mapGetters(["adminIndex"]),
  },
  methods: {
    // 选择图片
    chooseImage(
      callback,
      max = 9,
      is_hb = "",
      goods_id = "",
      media = "",
      type = ""
    ) {
      this.maxChooseImage = max;
      this.$refs.imageDialog.chooseImage(
        callback,
        is_hb,
        goods_id,
        media,
        type
      );
    },
    // 选择规格
    chooseSkus(callback) {
      this.$refs.skusDialog.chooseSkus(callback);
    },
    geturl() {
      let that = this;
      var url = decodeURI(decodeURI(location.search));
      var theRequest = new Object();

      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        let strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
      }
      if (theRequest.token) {
        this.handleMessage(theRequest.token);
      }
    },
    handleMessage(e) {
      axios
        .post("/admin/pc/ruiteng/getManagerByToken", {
          token: e,
        })
        .then((res) => {
          // 存储到vuex
          if (res.data.code != 200) return this.$message.error(res.data.msg);
          let data = res.data.data;
          // 存储到本地存储
          this.$store.commit("login", data);
          // 存储权限规则
          if (data.role && data.role.rules) {
            window.sessionStorage.setItem(
              "rules",
              JSON.stringify(data.role.rules)
            );
          }
          // 生成后台菜单
          this.$store.commit("createNavBar", data.tree);
          // 成功提示
          this.$message({
            showClose: true,
            message: "登录成功",
          });
          if (this.$openws.ws && this.$openws.ws.getState()) {
            this.$openws.ws.close();
            setTimeout(async () => {
              await this.$openws.openws();
              await this.$openws.connect(1);
            }, 500);
          } else {
            setTimeout(async () => {
              await this.$openws.openws();
              await this.$openws.connect(1);
            }, 500);
          }
          if (!JSON.parse(localStorage.getItem("allUserList"))) {
            this.getuser();
          }
          this.loading = false;
          // 跳转后台首页
          this.$router.push({
            name: this.adminIndex,
          });
        });
    },
    async getuser() {
      await axios
        .post(
          "/admin/User/userList",
          {
            page: 1,
            limit: 10000,
          },
          {
            token: true,
          }
        )
        .then(async (res) => {
          if (res.data.code == 200) {
            let allUserList = res.data.data.list;
            localStorage.setItem("allUserList", JSON.stringify(allUserList));
          }
        })
        .catch((error) => {});
    },
  },
};
</script>

<style>
@supports(bottom:env(safe-area-inset-bottom)){
  #app{
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
.index {
  margin: 0 26px !important;
  border-radius: 6px !important;
  padding-bottom: 10px !important;
  box-sizing: border-box;
}

::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 0;
}

::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  cursor: pointer;
  border-radius: 5px;
  background: rgba(0, 0, 0, 0.25);
  transition: color 0.2s ease;
}

.warnbtn {
  background-color: #ff9f24 !important;
  border-color: #ff9f24 !important;
}
</style>